export const WS_MODE_ADDITION = 'additionMode';
export const WS_MODE_DELETION = 'deletionMode';
